import { useEffect, useState } from "react";
import { _DashBoard } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import SeriesCharts from "../../../../core/graph/SeriesCharts";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

interface Props {
    kpi: any;
    idKpi: number;
    xint?: number;
    yint?: number;
}
export const DashBoardViewer = ({ kpi,idKpi, xint, yint }: Props) => {

    const _dashBoar = useDataBean(_DashBoard);
    const { bean, setBean, lista, setLista, instance, handleChange } = _dashBoar;
    const [report, setReport] = useState<any>({});

    const [xOption, setxOption] = useState<any>([]);
    const [yOption, setyOption] = useState<any>([]);
    const [head, setHead] = useState<any>([]);
    const [data, setData] = useState<any>([]);
    const [column, setColumn] = useState<number>(6);

    useEffect(() => {
        setBean(
            {
                xLength: xint ?? 3,
                yLength: yint ?? 5,
                Table: false
            }
        );
      
    }, [kpi,xint,yint])

    useEffect(() => {
        
        setTimeout(() => {
                getDashBoardInfo();
            }, 1000);

    }, [idKpi])

    useEffect(() => {

        if (report) {
            let xAxisProperties: any[] = report.XAxisProperties;
            if (xAxisProperties) {
                setxOption([...xAxisProperties]);
                let th = [];
                xAxisProperties.forEach(element => {
                    th.push(
                        {
                            title: element, property: element, visible: true
                        }
                    )
                });
                setHead(th);
            }
            if (report.List) {
                let td = [];
                report.List.forEach(element => {
                    td.push(
                        {
                            DataBeanProperties: element
                        }
                    )
                });
                setData(td);
            }
        }

    }, [report])

    const getDashBoardInfo = () => {

        console.log(bean);
        
        
            instance.getDashBoardInfo(kpi.IDDashBoard, bean.xLength ?? 3, bean.yLength ?? 5, _single.getAccountID()).then(
                (resp: any) => {
                    setReport(resp);
                }
            )
       
    }



    const renderGraph = (graph, index) => {

        const getHeader2 = (row) => {
            return (
                <div className="col-md-12">
                    <p>
                        <strong>{row.IDKpi} - {row.Name}</strong> <small>({row.ProcessTypeName})</small> <br />
                        <small>{row.Description}</small>
                    </p>
                </div>
            )
        }

        return (
            <div key={index} className="col-md-6">
                <SeriesCharts
                    xAxisProperties={graph.XAxisProperties}
                    list={graph.List}
                    header={getHeader2(graph)}
                    onlyGraph={!bean.Table}
                />
                {/* <PrintJson json={graph}/> */}

            </div>

        )

    }

    return (
        <div className="row">

            {(!xint && !yint) &&

                <>
                    <div className="col-md-2">
                        <label>Números de Períodos de Medición</label>
                        <input type="number" name="xLength" id="xLength" value={bean.xLength} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-md-2">
                        <label>Número de Registros de Detalle</label>
                        <input type="number" name="yLength" id="yLength" value={bean.yLength} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-md-2">
                        <BasicSwitch label="Mostrar Tabla" estado={bean.Table} eventChange={(e) => { setBean({ ...bean, "Table": e }) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton useMargin icon=" ri-file-search-fill" eventClick={getDashBoardInfo}>Buscar</BasicButton>
                    </div>
                </>

            }
            <div className="col-md-12 mt-3">
                <div className="row">
                    <div className="col-md-12">
                        <h5>{report.Name}</h5>
                    </div>
                    <div className="col-md-12">
                        {report.KpiList &&

                            <div className="row">
                                {report.KpiList.map((graph, index) => {
                                    return (
                                        renderGraph(graph.DataBeanProperties, index)
                                    )
                                })}
                            </div>
                        }
                    </div>
                </div>

            </div>
            <div className="col-md-12">

                {/* <PrintJson json={kpi} /> */}
                {/* <PrintJson json={data} /> */}
                {/* <PrintJson json={report} /> */}
            </div>
        </div>
    )
}